<template>
  <div class="tw-flex">
    <CruiseItineraryNavigationArrow
      :arrow-type="'prev'"
      :is-button-disabled="isPrevButtonDisable"
      @click="changeDay('prev')"
    />
    <CruiseItineraryNavigationArrow
      class="tw-ml-1"
      :is-button-disabled="isNextButtonDisable"
      @click="changeDay('next')"
    />
  </div>
</template>

<script>
import CruiseItineraryNavigationArrow from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/CruiseItineraryNavigationArrow/CruiseItineraryNavigationArrow";
import { EventBus } from "@/helpers/event-bus";

export default {
  name: "CruiseItineraryNavigation",

  components: { CruiseItineraryNavigationArrow },

  props: {
    itemsLength: {
      type: Number,
      required: true,
      default: 1,
    },
    cruiseIndex: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  computed: {
    isPrevButtonDisable() {
      return !this.cruiseIndex;
    },
    isNextButtonDisable() {
      return this.cruiseIndex === this.itemsLength - 1;
    },
  },

  methods: {
    changeDay(changeType) {
      EventBus.$emit("changeDate", changeType);
    },
  },
};
</script>
